<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="6" md="6" class="mb-md-0 mb-2">
          <b-form-group
            id="input-group-3"
            :label="$t('edu_courses.edu_courses')"
            label-for="input-3"
          >
            <v-select
              v-model="filters.edu_course"
              :options="edu_courses"
              class="w-100"
              label="for_v_select"
              :item-text="getFieldText"
              :reduce="(type) => type.id"
               @input="(val) => $emit('update', filters)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6" md="6" class="mb-md-0 mb-2">
          <b-form-group
            id="input-group-3"
            :label="$t('activities.type')"
            label-for="input-3"
          >
            <v-select
              v-model="filters.type"
              :options="types"
              class="w-100"
              label="value"
              :reduce="(type) => type.key"
              @input="(val) => $emit('update', filters)"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import Controller from "@/Controllers/EduCoursesController";
import ActivitiesController from '@/Controllers/ActivitiesController';
import Auth from "@/Apis/Auth";
import vSelect from "vue-select";
import { values } from "postcss-rtl/lib/affected-props";
let controller = new Controller();

export default {
  props: ["filters"],
  components: {
    vSelect,
  },
  data() {
    return {
      edu_courses: [],
      types:[]
    };
  },
  async created() {
    // const apiParams={};
    // apiParams.edu_program=localStorage.getItem("eduProgram");  
    // console.log("manaa si  ",apiParams);
    //  this.user = Auth.USER;
    // const data = await new EduProgramsController().getCourseByProgram();
    if(Auth.USER.account_type=='teacher'){
      const res =await new ActivitiesController().teacherCourses({edu_program:localStorage.getItem("eduProgram")});
      if(res){
        res.map((e)=>{
           this.edu_courses.push(e.course);
        })
        this.edu_courses.forEach((el)=>{
            el.for_v_select=el.code+' '+el.name;
        })
      }
      console.log(this.edu_courses);
    }else{
      this.edu_courses = await new Controller().GetAll();
      this.edu_courses.forEach((el)=>{
            el.for_v_select=el.code+' '+el.name;
        })
    }
    
    let t=['forum','homework', 'short_search', 'exam'];
        t.forEach((val)=>{
          this.types.push({
            key:val,
            value:this.$i18n.t('activities.'+val)
          });
        })
  },
  methods: {
    getFieldText(item){
      return item.code+' '+item.name;
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
